import {computed, inject, ref, unref, watch} from 'vue';
import {collapseContextKey, STATE_CHANGED_EVENT, MAX_PANELS_FOR_REGION_ROLE} from './constants';

export const useCollapseItem = (props, emit) => {
  const collapse = inject(collapseContextKey);
  const focusing = ref(false);
  const isClick = ref(false);
  const id = Math.random().toString(36).substring(7);
  const isActive = computed(() => collapse?.activeNames.value.includes(props.name));

  watch(isActive, (val) => {
    emit(STATE_CHANGED_EVENT, val);
  });

  const mountItem = () => {
    if (collapse?.props?.defaultActive && !isActive.value) {
      //activate them all if not accordian.
      //if accordian, only activate if nothing else is active
      if (!collapse?.props?.accordion || collapse?.activeNames.value.length < 1) {
        handleHeaderClick();
      }
    }
  };

  const handleFocus = () => {
    setTimeout(() => {
      if (!isClick.value) {
        focusing.value = true;
      } else {
        isClick.value = false;
      }
    }, 50);
  };

  const handleHeaderClick = () => {
    if (props.disabled) return;
    collapse?.handleItemClick(props.name, id);
    focusing.value = false;
    isClick.value = true;
  };

  const handleKeydown = () => {
    if (props.disabled) return;
    collapse?.handleItemClick(props.name, id);
  };
  const isSticky = computed(() => collapse?.props?.isSticky);

  const headerTag = computed(() => {
    return collapse?.props.headerLevel ? `h${collapse?.props.headerLevel}` : 'h3';
  });

  const shouldRenderAsRegion = computed(() => {
    return (
      collapse?.props?.accordion || collapse?.collapseContainer?.value?.children?.length < MAX_PANELS_FOR_REGION_ROLE
    );
  });

  return {
    focusing,
    id,
    isActive,
    handleFocus,
    handleHeaderClick,
    handleKeydown,
    isSticky,
    mountItem,
    headerTag,
    shouldRenderAsRegion,
  };
};

export const useCollapseItemDOM = (props, {focusing, isActive, id}) => {
  const collapse = inject(collapseContextKey);
  const rootClasses = computed(() => [
    'pdl-collapse-item',
    isActive.value ? 'is-active' : '',
    props.disabled ? 'is-disabled' : '',
  ]);
  const arrowName = computed(() => (isActive.value ? collapse?.props?.iconActive : collapse?.props?.iconInactive));
  const stickyHeaderOffset = computed(() => collapse?.props?.stickyHeaderOffset);
  const headClasses = computed(() => [
    isActive.value ? 'is-active' : '',
    collapse?.props?.iconPosition === 'left' ? 'flex-row-reverse' : '',
    `items-${collapse?.props?.alignIcon}`,
    collapse?.props?.headerClasses,
    focusing && !props.disabled ? 'focusing' : '',
  ]);
  const headWrapperClasses = computed(() => [collapse?.props?.isSticky ? 'is-sticky' : '']);
  const contentClasses = computed(() => [
    isActive.value ? 'is-active' : '',
    collapse?.props?.iconPosition === 'left' ? 'flex-row-reverse' : '',
    `items-${collapse?.props?.alignIcon}`,
    collapse?.props?.headerClasses,
    focusing && !props.disabled ? 'focusing' : '',
  ]);
  const iconClasses = computed(() => [isActive.value ? 'is-active' : '', collapse?.props?.iconClasses]);
  const scopedItemId = computed(() => `pdl-collapse-item-${unref(id)}`);
  const scopedHeadId = computed(() => `pdl-collapse-head-${unref(id)}`);
  const qaidChevronValue = computed(() => {
    if (!props.qaid || !props.qaid.length) {
      return '';
    }
    return `${props.qaid}${isActive.value ? 'ChevronExpanded' : 'ChevronCollapsed'}`;
  });
  const qaidValue = computed(() => {
    if (!props.qaid || !props.qaid.length) {
      return '';
    }
    return `${props.qaid}${isActive.value ? 'Expanded' : 'Collapsed'}`;
  });
  return {
    arrowName,
    stickyHeaderOffset,
    iconClasses,
    headClasses,
    headWrapperClasses,
    contentClasses,
    rootClasses,
    scopedItemId,
    scopedHeadId,
    qaidChevronValue,
    qaidValue,
  };
};
